module.exports = __webpack_public_path__ + "img/unilever_logo.dfef0fc5.svg";